<template>
  <v-app-bar color="white" elevation="1" class="toolbar">
    <v-toolbar-title class="ml-0 pl-3">
      <v-app-bar-nav-icon color="primary" @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="handleFullScreen">
      <v-icon color="primary">mdi-fullscreen</v-icon>
    </v-btn>
    <v-menu location="bottom" origin="center center" :offset="10" transition="scale-transition">
      <template #activator="{ props }">
        <v-btn icon size="large" v-bind="props">
          <v-icon color="primary">mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item, index) in items"
          :to="item.to"
          :href="item.href || undefined"
          @click="handleMenuAction(item, $event)"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
          :prepend-icon="item.icon"
          :title="item.title"
        >
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import Util from '@/util';

export default {
  name: 'app-toolbar',
  data: () => ({
    items: [
      {
        icon: 'mdi-account-circle',
        to: { name: 'ProfileInfoEdit' },
        title: 'Profil',
        action: 'profile',
      },

      {
        icon: 'mdi-power',
        href: '#',
        title: 'Déconnexion',
        action: 'logout',
      },
    ],
  }),
  methods: {
    handleMenuAction(item, event) {
      if (item.action === 'logout') {
        event.preventDefault();
        this.$bus.emit('APP_LOGOUT');
      }
    },
    handleDrawerToggle() {
      this.$bus.emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
  },
};
</script>

<style>
.toolbar {
  box-shadow:
    0 2px 1px -1px rgb(0 0 0 / 5%),
    0 1px 1px 0 rgb(0 0 0 / 5%),
    0 1px 3px 0 rgb(0 0 0 / 5%) !important;
}

.toolbar .v-toolbar__content {
  padding-left: 24px;
  padding-right: 24px;
}
</style>
